export default __webpack_public_path__ + "static/media/straw-dai.dc70fdd3.png";